<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #ac8400">SPD Record</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #f2f2f2">
      <router-link to="/dashboard">Dashboard</router-link>
      /
      <router-link to="/tba/spd_records">Motor SPD Records</router-link>
      /
      <b>Details</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active show"
                  id="profile-tab"
                  data-toggle="tab"
                  href="#profile"
                  role="tab"
                  aria-controls="profile"
                  aria-selected="true"
                  >SPD Record</a
                >
              </li>
            </ul>

            <div class="tab-content" id="myTabContent">
              <div
                class="tab-pane fade active show"
                id="spd-record"
                role="tabpanel"
                aria-labelledby="profile-tab"
              >
                <div class="card-body">
                  <!-- Form -->
                  <div class="row">
                    <div class="col-md-3 form-group mb-3">
                      <label>IC Number</label>
                      <input
                        class="form-control"
                        v-model="spd_record.ic_number"
                      />
                    </div>
                    <div class="col-md-3 form-group mb-3">
                      <label>Certificate Number</label>
                      <input
                        class="form-control"
                        v-model="spd_record.certificate_number"
                      />
                    </div>
                    <div class="col-md-3 form-group mb-3">
                      <label>Vehicle Number</label>
                      <input
                        class="form-control"
                        v-model="spd_record.vehicle_number"
                      />
                    </div>
                    <div class="col-md-3 form-group mb-3">
                      <label>Package Type</label>
                      <input
                        class="form-control"
                        v-model="spd_record.package_type"
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-3 form-group mb-3">
                      <label>Sum Insured (B$)</label>
                      <input
                        class="form-control"
                        v-model="spd_record.sum_covered"
                      />
                    </div>
                    <div class="col-md-3 form-group mb-3">
                      <label>Amount Paid (B$)</label>
                      <input
                        class="form-control"
                        v-model="spd_record.amount_paid"
                      />
                    </div>
                    <div class="col-md-3 form-group mb-3">
                      <label>NCD (%)</label>
                      <input class="form-control" v-model="spd_record.ncd" />
                    </div>
                    <div class="col-md-3 form-group mb-3">
                      <label>SPD Reference Number</label>
                      <input
                        class="form-control"
                        v-model="spd_record.spd_number"
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-3 form-group mb-3">
                      <label>Start Date</label>
                      <input
                        class="form-control"
                        v-model="spd_record.start_date"
                      />
                    </div>
                    <div class="col-md-3 form-group mb-3">
                      <label>End Date</label>
                      <input
                        class="form-control"
                        v-model="spd_record.end_date"
                      />
                    </div>
                    <div class="col-md-3 form-group mb-3">
                      <label>Purchased At</label>
                      <input
                        class="form-control"
                        v-model="spd_record.purchased_at"
                      />
                    </div>
                  </div>

                  <div class="row text-center" v-if="type == 2">
                    <button
                      v-if="!sure"
                      class="btn btn-primary"
                      @click="sure = true"
                    >
                      Push to SPD
                    </button>
                    <span v-if="sure" class="mx-2 py-2">Are you sure?</span>
                    <button
                      v-if="sure"
                      class="btn btn-success mx-2"
                      @click="repush(spd_record)"
                    >
                      Yes
                    </button>
                    <button
                      v-if="sure"
                      class="btn btn-danger mx-2"
                      @click="sure = false"
                    >
                      No
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          :is-full-page="fullPage"
        ></loading>
      </div>
    </div>
  </div>
</template>

<style>
.active {
  background: none;
}
</style>

<script>
import { createSpdRecord } from "@/services/SpdRecordService";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "tba_speed_record",
  components: {
    Loading,
  },
  update: [],
  data() {
    return {
      spd_record: {},
      sys_id: this.$route.params.sysId,
      reference_no: null,
      sure: false,
      isLoading: false,
      fullPage: true,
      type: 1,
    };
  },

  methods: {
    async repush(spd) {
      this.isLoading = true;

      try {
        const response = await createSpdRecord(spd);
        if (response.data.success) {
          swal("Successfully pushed to SPD", response.data.message, "success");
          await this.loadSpdEntry(this.dto.page_no);
        } else {
          swal("Try Again", response.data.message, "error");
          this.isLoading = false;
        }
      } catch (error) {
        swal("Try Again", error.response.data.message, "error");
      } finally {
        this.sure = false;
      }
      this.isLoading = false;
    },
  },

  async created() {
    this.type = this.$route.params.type

    if (this.$route.query.spdData) {
      this.spd_record = JSON.parse(this.$route.query.spdData);
    } else {
      await this.loaded(); // fallback to API
    }
  },
};
</script>
